import corporate from "../assets/images/OurServices/Corporate Event - 2 - 1080_1080.webp";
import wedding from "../assets/images/OurServices/Wedding Planning - 2 - 1080_1080.webp";
import social from "../assets/images/OurServices/Social Event - 3 - 1080_1080.webp";
import publicEvent from "../assets/images/OurServices/Public Event - 1280_720.webp";
import research from "../assets/images/OurServices/Research & Planning - 11 - 1080_1080.webp";
import creativeConcept from "../assets/images/OurServices/Creative Concept Development - 1 - 1080_1080.webp";
import coordination from "../assets/images/OurServices/Coordination & Execution - 9 - 1080_1080.webp";
import onGround from "../assets/images/OurServices/On-Ground Management - 6 - 1080_1080.webp";
import qualityDelivery from "../assets/images/OurServices/Quality Control & Delivery - 9 - 1080_1080.webp";
import expertiseHeader from "../assets/images/OurServices/Our Expertise - 3 - 1290_720.webp";
import endToEnd from "../assets/images/OurServices/End-To-End Event Management - 11 - 1080_1080.webp";
import strategic from "../assets/images/OurServices/Strategic Planning Approach - 9 - 1080_1080.webp";
import bannerHalf from "../assets/images/OurServices/Banner Half - 9 - 1280_720.webp";
import creativeSolutions from "../assets/images/OurServices/Creative & Customized Solutions - 8 - 1080_1080.webp";

export const GALLERY_CATEGORIES = [
  "All",
  "Corporate",
  "Wedding",
  "Social",
  "Public",
  "Production",
];

/** @typedef {{ id: string; src: string; title: string; category: string }} GalleryItem */

/** @type {GalleryItem[]} */
export const GALLERY_ITEMS = [
  {
    id: "corporate",
    src: corporate,
    title: "Corporate conferences & launches",
    category: "Corporate",
  },
  {
    id: "wedding",
    src: wedding,
    title: "Wedding celebrations",
    category: "Wedding",
  },
  {
    id: "social",
    src: social,
    title: "Social & private gatherings",
    category: "Social",
  },
  {
    id: "public",
    src: publicEvent,
    title: "Public & large-scale events",
    category: "Public",
  },
  {
    id: "banner-gala",
    src: bannerHalf,
    title: "Stage & experience design",
    category: "Production",
  },
  {
    id: "expertise",
    src: expertiseHeader,
    title: "Our expertise across formats",
    category: "Production",
  },
  {
    id: "research",
    src: research,
    title: "Research & planning phase",
    category: "Production",
  },
  {
    id: "creative-concept",
    src: creativeConcept,
    title: "Creative concept development",
    category: "Production",
  },
  {
    id: "coordination",
    src: coordination,
    title: "Coordination & execution",
    category: "Production",
  },
  {
    id: "on-ground",
    src: onGround,
    title: "On-ground management",
    category: "Production",
  },
  {
    id: "quality",
    src: qualityDelivery,
    title: "Quality control & delivery",
    category: "Production",
  },
  {
    id: "end-to-end",
    src: endToEnd,
    title: "End-to-end event management",
    category: "Production",
  },
  {
    id: "strategic",
    src: strategic,
    title: "Strategic planning approach",
    category: "Production",
  },
  {
    id: "custom",
    src: creativeSolutions,
    title: "Custom & creative solutions",
    category: "Production",
  },
];
